
	import { defineComponent, onMounted, ref } from "vue";
	import useDoctor from "@/store/DoctorState";
	import PatientCard from "@/components/PatientCard.vue";
	import InlineLoadingIndicator from "@/components/InlineLoadingIndicator.vue";
	import { Patient } from "@/domain/entities/Patient";
	import { useRouter } from "vue-router";

	export default defineComponent({
		name: "dashboard-doctor",
		components: {
			PatientCard, InlineLoadingIndicator
		},
		setup() {
			const router = useRouter();
			const { patients, loadPatients, selectPatient } = useDoctor();
			onMounted(async () => {
				await loadPatients();
			});
			function onClickPatient(patient: Patient) {
				selectPatient(patient);
				router.push("/patient");
			}

			let searchTerm = ref<string>("");
			let results = ref<Patient[] | null>(null);

			function filterWhileTyping() {
				if (patients === null) return;
				if (searchTerm.value.length < 4) {
					results.value = patients.value!;
					return;
				}

				let result = patients.value!.filter(
					(p) =>
						p.firstName.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
						p.lastName.toLowerCase().includes(searchTerm.value.toLowerCase())
				);
				results.value = result;
			}
			return { patients, results, onClickPatient, searchTerm, filterWhileTyping };
		},
	});
